import { styled } from 'styled-components'

import { Colors, Typography } from '@b-stock/fe-core/design-system'

import { CardBody } from '@/buyer-portal/components/layouts/CardLayout/card/ui'

export const Body = styled(CardBody)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const AddressRow = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
`

export const AddressContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.25rem;
`

export const AddressText = styled.div`
  ${Typography.Subtitle1}
  color: ${Colors.Semantic.Neutral.black};
  flex: 1;
`

export const AddressDisclaimer = styled.p`
  ${Typography.Caption}
  color: ${Colors.Semantic.Neutral.dark_grey};
  margin: 0;
`

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${Colors.Semantic.Neutral.medium_grey};
  margin: 0.25rem 0;
  width: 100%;
`

export const InfoRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0.25rem 0;
`

export const InfoLabel = styled.span`
  ${Typography.Subtitle2}
  align-items: center;
  color: ${Colors.Semantic.Neutral.very_dark_grey};
  display: flex;
  gap: 0.25rem;
`

export const InfoValue = styled.span`
  ${Typography.Subtitle1}
  color: ${Colors.Semantic.Neutral.black};
`

export const FlatRateTag = styled.div`
  ${Typography.Overline2}
  align-items: center;
  background: ${Colors.Semantic.Success.highlight};
  border-radius: 0.25rem;
  color: ${Colors.Semantic.Neutral.white};
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  width: 100%;
`

export const FlatRateLabel = styled.span`
  flex: 1;
`

export const InfoIcon = styled.span`
  color: ${Colors.Semantic.Neutral.dark_grey};
`

export const HeaderInfoIcon = styled(InfoIcon)`
  margin-left: 0.25rem;
`

// Sentence stating who owns freight on a Seller Collects listing, shown in
// place of a rate B-Stock does not have.
export const SellerCollectsTerms = styled.p`
  ${Typography.Body3}
  color: ${Colors.Semantic.Neutral.dark_grey};
  margin: 0;
`
